import React from 'react';

import { ToastProvider } from 'js/design_system/toasts/ToastProvider';

import { CitationGenerator } from './CitationGenerator';
import {
  CITATION_STYLES,
  CitationStyle,
  CitationStyleId,
  DEFAULT_HUB_STYLE,
} from './styles';

export type CitationGeneratorIslandProps = {
  defaultStyle?: CitationStyleId;
  styles?: CitationStyle[];
};

export default function CitationGeneratorIsland({
  defaultStyle = DEFAULT_HUB_STYLE,
  styles = CITATION_STYLES,
}: CitationGeneratorIslandProps): React.ReactElement {
  return (
    <ToastProvider>
      <CitationGenerator defaultStyle={defaultStyle} styles={styles} />
    </ToastProvider>
  );
}
